module.exports = __webpack_public_path__ + "img/open-account-guide.7a17f469.svg";